angular.module('zc.projects')

.directive 'campaignBotbonnieStep', (Campaign, $translate) ->
  restrict: 'E'
  scope:
    campaign: '='
    botbonnieForm: '='
  templateUrl: '/templates/projects.campaigns/views/directives/campaign_botbonnie_step.html'
  link: (scope, element, attrs) ->
    scope.triggers = [
      { name: $translate.instant('projectsCampaignsViews.directives.campaignBotbonnieStep.triggers.timing'), value: 'timing' },
      { name: $translate.instant('projectsCampaignsViews.directives.campaignBotbonnieStep.triggers.conversion'), value: 'conversion' }
    ]
    scope.triggerRulesMaxLength = 5
    scope.triggerErrors = []

    scope.disableBotbonnieForm = () ->
      supportedTemplates = [
          'timesale_ver5_pc',
          'timesale_ver5_sp',
          'timesale_ver5_devicefree',
          'timesale_ver5_devicefree_1step',
        ]
      !supportedTemplates.includes(scope.campaign.template_type)


    scope.addRule = () ->
      scope.campaign.botbonnie_trigger_rules ||= []
      scope.campaign.botbonnie_trigger_rules.push({})

    scope.deleteRule = (rule) ->
      _.remove(scope.campaign.botbonnie_trigger_rules, (t) -> t.$$hashKey == rule.$$hashKey)
      scope.validateTriggerRules()

    scope.validateTriggerRules = () ->
      scope.botbonnieForm.$error = {}
      scope.triggerErrors = []
      formErrors = {}
      limit = scope.campaign.element.message.limit
      conversionRulesCount = 0
      timingRules = []

      if scope.campaign.enable_botbonnie_integration and (scope.campaign.botbonnie_trigger_rules.length == 0 or scope.campaign.botbonnie_trigger_rules == undefined)
        formErrors.triggerUndefined = new Error($translate.instant('projectsCampaignsViews.directives.campaignBotbonnieStep.errors.triggers_undefined'))

      for trigger in scope.campaign.botbonnie_trigger_rules
        if trigger.module == undefined or trigger.module == ""
          formErrors.moduleUndefined = new Error($translate.instant('projectsCampaignsViews.directives.campaignBotbonnieStep.errors.module_undefined'))

        else if trigger.trigger == 'conversion'
          conversionRulesCount += 1
          if conversionRulesCount > 1
            formErrors.multipleConversion = new Error($translate.instant('projectsCampaignsViews.directives.campaignBotbonnieStep.errors.multiple_conversion'))

        else if trigger.trigger == 'timing' or trigger.trigger == null
          timingRules.push(trigger)

          if trigger.minutes > limit
            overLimit = true
            formErrors.overLimit = new Error($translate.instant('projectsCampaignsViews.directives.campaignBotbonnieStep.errors.over_limit', { limit: limit }))

          else if trigger.minutes == undefined
            minutesUndefined = true
            formErrors.minutesUndefined = new Error($translate.instant('projectsCampaignsViews.directives.campaignBotbonnieStep.errors.minutes_undefined'))

      duplicateMinutes = _.find(Object.values(_.countBy(timingRules, (t) -> t.minutes)), (t) -> t > 1)
      if duplicateMinutes
        formErrors.duplicateMinutes = new Error($translate.instant('projectsCampaignsViews.directives.campaignBotbonnieStep.errors.duplicated_minutes'))

      if Object.keys(formErrors).length > 0
        scope.botbonnieForm.$setValidity('triggers', false)
        scope.triggerErrors = Object.values(formErrors)
        return

      scope.botbonnieForm.$valid = true



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects.campaigns/directives/campaign_botbonnie_step.coffee